module.exports = __webpack_public_path__ + "img/huoyan.f5bdbcad.png";